import {
  ArticleAccounting,
  ArticleDirection,
  ArticleIntegration,
  ArticleProfile,
  ArticleProtection,
  ArticleReading,
  ArticleReceipt,
} from '../../../../../../../../assets/images'
import { PopularArticleItem } from '../types/popularArticleItem'

export const popularArticles: Record<string, PopularArticleItem[]> = {
  DK: [
    {
      title: 'Fakturering',
      description: 'Opret, send og følg dine fakturaer – hurtigt og korrekt.',
      url: 'https://www.billy.dk/support/categories/fakturering/',
      Icon: ArticleReceipt,
    },
    {
      title: 'Regninger',
      description: 'Bogfør og betal regninger, så dit regnskab altid stemmer.',
      url: 'https://www.billy.dk/support/categories/regninger/',
      Icon: ArticleAccounting,
    },
    {
      title: 'Få styr på moms',
      description: 'Beregn, bogfør og indberet moms uden besvær.',
      url: 'https://www.billy.dk/support/categories/moms/',
      Icon: ArticleProtection,
    },
  ],
  FR: [
    {
      title: 'Gestion du compte',
      description: 'Configurez votre compte et gérez vos paramètres.',
      url: 'https://help.shine.fr/shine-facture/fr/collections/17892018-gestion-de-compte',
      Icon: ArticleProfile,
    },
    {
      title: 'Facturation électronique',
      description: 'Comprenez la facturation électronique et assurez votre conformité.',
      url: 'https://help.shine.fr/shine-facture/fr/collections/17892042-facturation-electronique',
      Icon: ArticleReceipt,
    },
    {
      title: 'Outil de facturation',
      description: 'Créez, envoyez et suivez vos factures facilement, au quotidien.',
      url: 'https://help.shine.fr/shine-facture/fr/collections/17201594-outil-de-facturation',
      Icon: ArticleDirection,
    },
  ],
  NL: [
    {
      title: 'Koppel je bank aan Shine',
      description: 'Verbind je bankrekening en automatiseer je transacties.',
      url: 'https://shine.co/nl/help-center/category/externe-bankrekening-koppelen',
      Icon: ArticleAccounting,
    },
    {
      title: 'Ga aan de slag in 4 stappen',
      description: 'Start snel met Shine en zet alles correct op.',
      url: 'https://shine.co/nl/help-center/category/aan-de-slag',
      Icon: ArticleReceipt,
    },
    {
      title: 'Importeer je contacten naar Shine',
      description: 'Voeg je klanten toe en begin direct met factureren.',
      url: 'https://shine.co/nl/help-center/category/verkoopfacturen-offertes',
      Icon: ArticleReading,
    },
  ],
  DE: [
    {
      title: 'Steuerliche Grundlagen',
      description: 'Verbinde dein Bankkonto und automatisiere deine Transaktionen.',
      url: 'https://intercom.help/kontist/de/collections/12949872-steuerliche-grundlagen',
      Icon: ArticleAccounting,
    },
    {
      title: 'Profil, Datenschutz & Kontoverwaltung',
      description: 'Richte dein Profil ein und verwalte Datenschutz und Kontoeinstellungen.',
      url: 'https://intercom.help/kontist/de/collections/12947784-profil-datenschutz-kontoverwaltung',
      Icon: ArticleReceipt,
    },
    {
      title: 'Integrationen',
      description: 'Füge Kunden hinzu und starte direkt mit dem Rechnungsstellen.',
      url: 'https://intercom.help/kontist/de/collections/12947563-integrationen',
      Icon: ArticleIntegration,
    },
  ],
}
